import React from 'react';
import useIsMuted from '../../Components/MainWindow/Components/Pages/SettingsPage/SubPages/PreferencesSubPage/Components/DevicesContainer/Hooks/useIsMuted';
import useIsAppEnabled from '../../LiveContext/ApplicationSyncContext/useIsAppEnabled';
import { AudioConfig } from '../../LiveContext/AudioConfigContext/Hooks/useAudioConfig';
import useAudioConfigContext from '../../LiveContext/AudioConfigContext/useAudioConfigContext';
import { useDualChannelDevices } from '../../LiveContext/NewSessionContext/Contexts/SessionStoreContextProvider/SessionStoreContextProvider';
import { DualChannelDeviceConfig } from '../../LiveContext/NewSessionContext/Contexts/WebsocketConnectionProviders/WebsocketApiConnectionContext/types';

export interface AudioDeviceConfig {
  mono?: {
    config: AudioConfig;
    muted?: boolean;
    device?: MediaDeviceInfo
  },
  dual?: DualChannelDeviceConfig;
  disabled: boolean;
  isLoading: boolean;
}

export default function useAudioDeviceConfig(): AudioDeviceConfig {
  const monoConfig = useAudioConfigContext();
  const dualChannelDevices = useDualChannelDevices();
  const isAppEnabled = useIsAppEnabled();
  const muted = useIsMuted();

  const res = React.useMemo(() => {
    if (isAppEnabled) {
      return {
        dual: dualChannelDevices ?? undefined,
        disabled: !dualChannelDevices?.input.selected || !dualChannelDevices?.output.selected,
        isLoading: dualChannelDevices === null,
      };
    }

    const device = monoConfig.devices?.find((d) => d.deviceId === monoConfig.deviceId);
    return {
      mono: {
        config: monoConfig,
        muted,
        device,
      },
      disabled: !device,
      isLoading: monoConfig.permissionStatus === null,
    };
  }, [isAppEnabled, dualChannelDevices, muted, monoConfig]);

  return res;
}
